// extracted by mini-css-extract-plugin
export var availabilityItem = "parking-availability-row-module--availabilityItem--31344";
export var availabilityText = "parking-availability-row-module--availabilityText--ecc77";
export var crowdedStatusItem = "parking-availability-row-module--crowdedStatusItem--be048";
export var emptyStatusItem = "parking-availability-row-module--emptyStatusItem--53571";
export var fullStatusItem = "parking-availability-row-module--fullStatusItem--7a8bb";
export var info = "parking-availability-row-module--info--1e8e9";
export var invalidStatusItem = "parking-availability-row-module--invalidStatusItem--1ade1";
export var row = "parking-availability-row-module--row--106c5";
export var statusItemText = "parking-availability-row-module--statusItemText--c251f";